$(document).on('turbolinks:load', function () {
  $("#pi").on("click", function(event) {
    showPiForProduct($("#product option:selected").data("pi"), 0);
  });

  $("#searchsubmit").on("click", function(event){
    event.preventDefault();
    var query = encodeURIComponent($("#searchquery").val())
    var product =  encodeURIComponent($("#product").val())
    $.post( "/search/" + product + "?text="+query, function( data ) {
      searchResults = data;
      renderSearchPage(searchResults, 0);
    });
  });
});

var searchResults = [];
var itemsperpage = 4;

window.showPDFOnSearch = function(pdf, page) {
  $(".pdf-pop").show();

  $(".pdf-pop .popup-content").html('<iframe src="/pdfviewer?file='+ encodeURIComponent(pdf) +'#page=' +  page + '" width="100%" height="600px" />')
}

function showPiForProduct(pilink, pipage) {
  $(".pdf-pop").show();

  $(".pdf-pop .popup-content").html('<iframe src="/pdfviewer?file='+ encodeURIComponent(pilink) +'#page=' +  pipage + '" width="100%" height="600px" />')
}


function renderSearchPage(results, pagenumber) {
  renderSearchResults(results.slice(0, itemsperpage));
}


function renderSearchResults(results) {
  $('#search-results').children().not(':first').remove();

  if (results.length <= 0) {
    renderNoResults();
  }
  for (var i = 0; i < results.length; i++) {
    renderSearchResult(results[i])
  }
  $("#search-results").show()
}

function renderNoResults() {
  $("#search-results").append('<div class=result-item> \
    <div class="result-icon"></div> \
    <div class="result-title">No relevant documents found.</div> \
    <div class="result-download"> \
    </div></a> \
  </div>')
}

function renderSearchResult(result) {
  $("#search-results").append('<div class=result-item> \
    <div class="result-icon"><i class="far ' + iconForFiletype(result.filetype)  + '"></i></div> \
    <div class="result-title">' + result.title + '</div> \
    <a href="javascript:void(0)" onClick="showPDFOnSearch(\'' +  result.downloadurl  +'\', \'\')"><div class="result-download searchmed-button searchmed-gradient"> \
      View \
      <img class="button-arrow" src="' + window.download_path + '" alt=""> \
    </div></a> \
  </div>')
}

function iconForFiletype(filetype) {
  switch (filetype) {
    case "doc":
    case "docx":
      return "fa-file-word"
      break;
    case "ppt":
    case "pptx":
      return "fa-file-powerpoint"
      break;
    case "pdf":
      return "fa-file-pdf"
      break;
    default:
    return "fa-file"
  }
}
